const state = {
  lookupMasterData: [],
  lookupData: []
};

const mutations = {
  SET_LOOKUP_MASTER(state, payload) {
    state.lookupMasterData = Object.values(payload);
  },
  SET_LOOKUP_DATA(state, payload) {
    state.lookupData = Object.values(payload);
  }
};

const actions = {
  async fetchLookupMasterData({commit}) {
    try {
      const response = await window.axios.get(`${process.env.VUE_APP_URL}/lookup/list`);
      const sortedResponse = response.data.sort((a,b) => a.DisplayValue.localeCompare(b.DisplayValue));
      commit('SET_LOOKUP_MASTER', sortedResponse);
      return sortedResponse;
    } catch (error) {
      console.error('Error setting lookups master:', error);
      throw error;
    }
  },
  async fetchLookupData({commit}, lookupMasterName) {
    try {
      const response = await window.axios.get(`${process.env.VUE_APP_URL}/lookup/lookupmaster/${lookupMasterName}`);
      const sortedResponse = response.data.sort((a,b) => a.DisplayValue.localeCompare(b.DisplayValue));
      commit('SET_LOOKUP_DATA', sortedResponse);
      return sortedResponse;
    } catch (error) {
      console.error('Error setting lookups list:', error);
      throw error;
    }
  },
  async createLookup({ commit, dispatch }, { masterName, data }) {
    try {
      const response = await window.axios.post(`${process.env.VUE_APP_URL}/lookup`, data);
      await dispatch('fetchLookupData', masterName);
      return response.data;
    } catch (error) {
      console.error('Error creating lookup:', error);
      throw error;
    }
  },
  async updateLookup({ commit, state }, { id, data }) {
    try {
       await window.axios.put(`${process.env.VUE_APP_URL}/lookup/${id}`, data);
    } catch (error) {
      console.error('Error updating lookup:', error);
      throw error;
    }
  },
  async deleteLookup({ commit }, id) {
    try {
      await window.axios.delete(`${process.env.VUE_APP_URL}/lookup/${id}`);
      return true;
    } catch (error) {
      console.error('Error deleting lookup:', error);
      throw error;
    }
  }
};

const getters = {
  lookupMasterData: (state) => state.lookupMasterData,
  lookupData: (state) => state.lookupData,
  getMasterIdByName: state => name => {
    const item = state.lookupMasterData.find(x => x.Name === name);
    return item ? item.LookupMasterID : null;
  },
  getMasterValueByName: state => name => {
    const item = state.lookupMasterData.find(x => x.Name === name);
    return item ? item.DisplayValue : null;
  }
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
};
